/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Cta_To_ExamsInputs */

const da_forside_cta_to_exams = /** @type {(inputs: Forside_Cta_To_ExamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Til dine prøver`)
};

/** @type {(inputs: Forside_Cta_To_ExamsInputs) => LocalizedString} */
const en_forside_cta_to_exams = da_forside_cta_to_exams;

/**

* @param {Forside_Cta_To_ExamsInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_cta_to_exams = /** @type {((inputs?: Forside_Cta_To_ExamsInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Cta_To_ExamsInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_cta_to_exams(inputs)
	return /** @type {LocalizedString} */ ("Til dine prøver")
});